import { ExClinVarResponse } from '@/types/clinvar.model';

export class ClinvarResolver {
  // Resolved against document.baseURI so the request lands at whatever mount
  // point the SPA is served from — `/api/clinvar` on the subdomain deploy and
  // `/clinicalsummary/api/clinvar` on the path-mounted Worker deploy.
  private readonly baseUrl = new URL('api/clinvar', document.baseURI).toString();

  constructor() {

  }

  async resolveVCV(vcvId: string, alleleId: string): Promise<ExClinVarResponse> {

    const url = `${this.baseUrl}?vcvId=${vcvId}&alleleId=${alleleId}`;
    
    try {
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`ClinVar API request failed: ${response.statusText}`);
      }

      const parsed: ExClinVarResponse = await response.json();
      

      return parsed;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`Failed to resolve VCV ${vcvId} and allele ${alleleId}: ${error.message}`);
      }
      throw new Error(`Failed to resolve VCV ${vcvId} and allele ${alleleId}: Unknown error`);
    }
  }


} 